// extracted by mini-css-extract-plugin
module.exports = {"playStatus":"_161sdKb","players":"_1GCetDJ","oval":"_eDd76R6","running":"_1uL7TRn","pulse":"_2xzyu3x","completed":"_2X8ErI7","registered":"_3tRWRAW"};